import { render, staticRenderFns } from "./BaseConsent.vue?vue&type=template&id=6055d3a4&"
import script from "./BaseConsent.vue?vue&type=script&lang=ts&"
export * from "./BaseConsent.vue?vue&type=script&lang=ts&"
import style0 from "./BaseConsent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports